// extracted by mini-css-extract-plugin
module.exports = {"container":"Section2-module--container--uQdJM","title":"Section2-module--title--2D0bS","extra":"Section2-module--extra--3oxRs","centered":"Section2-module--centered--3x6yu"};